import React from 'react';
import PropTypes from 'prop-types';

export default class Header extends React.PureComponent {
  render() {
    const { isEditMode, isMigrateMode } = this.props;

    return (
      <h4 className="create-alert-dialog-title">{isEditMode ? 'Edit' : isMigrateMode ? 'Migrate' : 'Create'} Alert</h4>
    );
  }
}

Header.propTypes = {
  isEditMode: PropTypes.bool,
  isMigrateMode: PropTypes.bool,
};
